/**
 * GB — Image with blocks (Dawn-style custom element, no dependencies).
 *
 * Desktop only: turns the block list into an ARIA tablist. Selecting a row
 *   1. moves the active highlight (CSS, driven by the Container color scheme),
 *   2. swaps the stacked media image to that block's matching image,
 *   3. reveals that row's sub-copy.
 * Roving tabindex + arrow/Home/End keys, with automatic activation (WAI-ARIA
 * tabs pattern). Mobile uses Dawn's <slider-component> instead — untouched here.
 */
if (!customElements.get('image-with-blocks')) {
  customElements.define(
    'image-with-blocks',
    class ImageWithBlocks extends HTMLElement {
      connectedCallback() {
        this.rows = Array.from(this.querySelectorAll('.image-with-blocks__row'));
        this.mediaItems = Array.from(this.querySelectorAll('.image-with-blocks__media-item'));
        if (this.rows.length === 0) return;

        this.addEventListener('click', (event) => {
          const row = event.target.closest('.image-with-blocks__row');
          if (!row || !this.contains(row)) return;
          this.select(this.rows.indexOf(row), false);
        });

        this.addEventListener('keydown', this.onKeydown.bind(this));
      }

      onKeydown(event) {
        const currentIndex = this.rows.findIndex((row) => row.getAttribute('tabindex') === '0');
        if (currentIndex === -1) return;

        let nextIndex = null;
        switch (event.key) {
          case 'ArrowDown':
          case 'ArrowRight':
            nextIndex = (currentIndex + 1) % this.rows.length;
            break;
          case 'ArrowUp':
          case 'ArrowLeft':
            nextIndex = (currentIndex - 1 + this.rows.length) % this.rows.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = this.rows.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.select(nextIndex, true);
      }

      select(index, focusRow) {
        if (index < 0 || index >= this.rows.length) return;

        this.rows.forEach((row, i) => {
          const active = i === index;
          row.classList.toggle('is-active', active);
          row.setAttribute('aria-selected', active ? 'true' : 'false');
          row.setAttribute('tabindex', active ? '0' : '-1');
        });

        this.mediaItems.forEach((item, i) => {
          item.classList.toggle('is-active', i === index);
        });

        if (focusRow) this.rows[index].focus();
      }
    }
  );
}
